export const NETWORK_LATENCY = {
  STRONG: 100,
  AVERAGE: 200,
  WEAK: 300,
  VERY_WEAK: 400,
};
